var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dish"},[_c('InfoBubble',{staticClass:"dish__info"}),_c('figure',{staticClass:"dish__image",style:({ backgroundImage: ("url(" + _vm.image + ")") })})],1)}
var staticRenderFns = []

export { render, staticRenderFns }